import { useSelectedNetworkContext } from "../contexts/NetworkContext/context";
import { useNetworksContext } from "../contexts/NetworksProvider";
import useAuth from "../routes/login/AuthContext";

export const useLogout = () => {
  const { logout } = useAuth();
  const { setSelectedNetworkId } = useSelectedNetworkContext();
  const { setNetworks } = useNetworksContext();

  const handleLogout = () => {
    setSelectedNetworkId(0);
    setNetworks([]);
    logout();
  };

  return handleLogout;
};
